// extracted by mini-css-extract-plugin
export default {"header":"header__AMwG30Qd","logo":"logo__DHfiU_fd","card":"card__X1SvopBV","acceptButton":"acceptButton__frTHM9kz"};